import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
